import { render, staticRenderFns } from "./PartnerMainCommissions.vue?vue&type=template&id=04e01ed2&"
import script from "./PartnerMainCommissions.vue?vue&type=script&lang=js&"
export * from "./PartnerMainCommissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04e01ed2')) {
      api.createRecord('04e01ed2', component.options)
    } else {
      api.reload('04e01ed2', component.options)
    }
    module.hot.accept("./PartnerMainCommissions.vue?vue&type=template&id=04e01ed2&", function () {
      api.rerender('04e01ed2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/PartnerMainCommissions.vue"
export default component.exports